import { AfterViewInit, Component, Inject, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppUserState } from '../../stores/states/app.state';

@Component({
  selector: 'app-user-onboarding',
  templateUrl: './user-onboarding.component.html',
  styleUrl: './user-onboarding.component.scss'
})
export class UserOnboardingComponent implements OnInit, AfterViewInit, OnChanges {

  currentUser!: AppUserState;

  predefinedColors: string[] = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57',
    '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
    '#C44569', '#F8B500', '#6C5CE7', '#A29BFE', '#FD79A8',
    '#E17055', '#00B894', '#0984E3', '#6C5CE7', '#FDCB6E'
  ];

  selectedColor: string = '';
  userInitials: string = '';
  showAdvancedPicker: boolean = false;
  currentStep: number = 1;

  constructor(
    public dialogRef: MatDialogRef<UserOnboardingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentUser: AppUserState; onlyColor?: boolean; }
  ) {
    this.currentUser = data.currentUser;
    this.onlyColor = !!data.onlyColor;
  }

  onlyColor: boolean = false;

  ngOnInit(): void {
    this.generateUserInitials();
    if (this.onlyColor) {
      this.currentStep = 2;
    }
    // Set selectedColor to user's current avatarBgColor if available
    if (this.currentUser?.settings?.avatarBgColor) {
      this.selectedColor = this.currentUser.settings.avatarBgColor;
    } else {
      this.setRandomColor();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentUser'] && this.currentUser?.settings?.avatarBgColor) {
      this.selectedColor = this.currentUser.settings.avatarBgColor;
    }
  }

  ngAfterViewInit(): void {
  }

  private generateUserInitials(): void {
    if (this.currentUser) {
      const firstName = this.currentUser.name || '';
      const lastName = this.currentUser.lastName || this.currentUser.family_name || '';

      this.userInitials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    }
  }

  private setRandomColor(): void {
    const randomIndex = Math.floor(Math.random() * this.predefinedColors.length);
    this.selectedColor = this.predefinedColors[randomIndex];
  }

  nextStep(): void {
    if (this.currentStep < 2) {
      this.currentStep++;
    }
  }

  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  selectPredefinedColor(color: string): void {
    this.selectedColor = color;
    this.showAdvancedPicker = false;
  }

  toggleAdvancedPicker(): void {
    this.showAdvancedPicker = !this.showAdvancedPicker;
  }

  onColorChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.selectedColor = target.value;
  }

  completeOnboarding(): void {
    this.dialogRef.close(this.selectedColor);
  }

  closeOnboarding(): void {
    this.dialogRef.close(null);
  }

  getUserDisplayName(): string {
    if (this.currentUser) {
      return this.currentUser.name || 'User';
    }
    return 'User';
  }

  get isCustomColor(): boolean {
    return !!this.selectedColor && !this.predefinedColors.includes(this.selectedColor);
  }
}
